import { Injectable } from '@angular/core';
import { Broker, MonitoredHttpService } from '@c4/core';

@Injectable()
export class NetworkService {

  constructor(
    private broker: Broker,
    private http: MonitoredHttpService) { }

  public rebootDevice = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {

      let postdata: any = {'cmd':'reboot'};
      if (ip)
        postdata["ip"] = ip;

      this.http.setRebootRequested(true);

      this.broker.call(
          { method: 'POST',
            path: '/api/v1/sysman',
            data: postdata
          }).then(
              // this most likely doesn't return
              (response: any) => {
                  resolve(response);
              },
              (error: any) => {
                  reject(error);
              });
      });
  }

  public getNetworkInfo = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {      
    this.broker.call(
        { method: 'GET',
          path: '/api/v1/sysman/network?isreal=true' + (ip ? "&ip="+ip : "")
        }).then(
            (response: any) => {
                resolve(response);
            },
            (error: any) => {
                reject(error);
            });
    });
  }

  public saveNetworkInfo = (config : any, ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {

    if (ip)
      config["ip"] = ip;

    this.broker.call({
          method: 'POST',
          path: '/api/v1/sysman/network' + (ip ? "?ip="+ip : ""),
          queryString: { timeout:300000 },
          data: config
        }).then(
          (response: any) => {
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  public getWirelessNetworks = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {
    this.broker.call({
      method: 'GET',
      path:'/api/v1/sysman/network/wlan0/scan' + (ip ? "?ip="+ip : "")
        }).then(
          (response: any) => {
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  public getNetworkName = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {
    this.broker.call({
      method: 'GET',
      path:'/api/v1/sysman/hostname' + (ip ? "?ip="+ip : "")
        }).then(
          (response: any) => {
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  public saveNetworkName = (hostname : string, ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {

        var putdata: any = {};
        if (ip)
          putdata["ip"] = ip;
        putdata["hostname"] = hostname;
        this.broker.call({
          method: 'PUT',
          path: '/api/v1/sysman/hostname',
          data: putdata
        }).then(
          (response: any) => {
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  public getSysmanInfo = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {

    // check if device is available and running sysman
    let request: any = {
        method: 'GET',
        path: '/api/v1/sysman' + (ip ? "?ip=" + ip : "")
    };

    this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  // determine devices that network config is not supported
  public isNotSupportedDevice(hostname : string): boolean {
    let result: boolean = false;
    if (hostname) {
      result = (hostname.indexOf("sony-avr") > -1);
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/network.service.ts